import { render, staticRenderFns } from "./addSpeaking.vue?vue&type=template&id=670c8f40&scoped=true&"
import script from "./addSpeaking.vue?vue&type=script&lang=js&"
export * from "./addSpeaking.vue?vue&type=script&lang=js&"
import style0 from "./addSpeaking.vue?vue&type=style&index=0&id=670c8f40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670c8f40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('670c8f40')) {
      api.createRecord('670c8f40', component.options)
    } else {
      api.reload('670c8f40', component.options)
    }
    module.hot.accept("./addSpeaking.vue?vue&type=template&id=670c8f40&scoped=true&", function () {
      api.rerender('670c8f40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/speaking/components/addSpeaking.vue"
export default component.exports